<template>
  <v-card class="grey lighten-4 elevation-0">
    <v-card-text v-if="!fatalError">
      <v-container fluid>

        <v-form @submit.prevent.stop="submit" v-if="!submited">

          <v-layout row>
            <v-flex xs12 md3>
              <v-subheader>Informações do trabalho</v-subheader>
            </v-flex>
            <v-flex xs12 md9>
              <v-select
                item-text="name"
                item-value="id"
                label="Curso"
                data-vv-as="Curso"
                data-vv-name="exam.course"
                prepend-icon="class"
                required
                :errors="vErrors.collect('exam.course')"
                :disabled="isEdition"
                :no-data-text="noDataText"
                :items="userCourses"
                v-model="exam.course"
                v-validate="'required'"
                @change="getExamTypes"
              ></v-select>

              <v-select
                v-model="exam.type" v-validate="'required'"
                :errors="vErrors.collect('exam.type')" :disabled="studentChecked" :no-data-text="noDataText" :items="nCourseTypes"
                label="Tipo" data-vv-as="Tipo" data-vv-name="exam.type" prepend-icon="create" item-text="name" item-value="id" required
              ></v-select>

              <template>
                <v-text-field
                  label="Título" v-model="exam.title" data-vv-as="Título" data-vv-name="exam.title"
                  v-validate="" :errors="vErrors.collect('exam.title')" :readonly="readonly"
                  prepend-icon="title"
                ></v-text-field>

                <!-- <v-text-field
                  label="Tema" v-model="exam.topic" data-vv-as="Tema" data-vv-name="exam.topic"
                  v-validate="" :errors="vErrors.collect('exam.topic')" :readonly="readonly"
                  prepend-icon="subject"
                ></v-text-field> -->
              </template>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>

          <v-layout row>
            <v-flex xs12 md3>
              <v-subheader>Banca Semestre</v-subheader>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                :items="semesters" item-text="name" item-value="id"
                label="Semestre"
                prepend-icon="date_range"
                v-model="exam.semesters"
                v-validate="'required'"
                data-vv-name="Semestre"
                :errors="vErrors.collect('Semestre')"
                required
              ></v-select></v-flex>
          </v-layout>

          <v-divider></v-divider>

          <v-layout row>
            <v-flex xs12 md3>
              <v-subheader>Identificação do aluno</v-subheader>
            </v-flex>
            <v-flex xs12 md9>
              <v-btn dark small class="green" @click="exam.student.push('')" v-if="!isEdition">
                <v-icon dark>add</v-icon> Adicionar Aluno
              </v-btn>
              <v-select
                label="Aluno"
                v-model="exam.student"
                prepend-icon="person"
                data-vv-as="Aluno"
                data-vv-name="exam.student"
                v-validate="'required'"
                :errors="vErrors.collect('exam.student')"
                required autocomplete
                :disabled="!exam.course"
                :loading="studentLoading"
                :no-data-text="noDataText"
                :items="students"
                :search-input.sync="searchStudentVal"
                item-text="name_and_id"
                item-value="id"
                v-if="false"></v-select> <!--deletar-->

              <template v-for="(student, idx) in exam.student" v-key="idx">
                <v-layout row v-if="!isEdition">
                  <v-flex xs12 sm11>
                    <v-select
                      :label="'Aluno '+(idx+1)"
                      v-model="exam.student[idx]"
                      prepend-icon="person"
                      data-vv-as="Aluno"
                      data-vv-name="exam.student"
                      v-validate="'required'"
                      :errors="vErrors.collect('exam.student')"
                      required autocomplete
                      :disabled="!exam.course"
                      :loading="studentLoading"
                      :no-data-text="noDataText"
                      :rules="[(v) => !!v || 'O Aluno ' +(idx+1)+ ' precisa ser informado']"
                      :items="students"
                      :search-input.sync="searchStudentVal"
                      item-text="name_and_id"
                      item-value="id">
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm1 v-if="!readonly">
                    <v-btn fab dark small class="red" @click="exam.student.splice(idx, 1)">
                      <v-icon dark>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-layout v-if="isEdition">
                  <v-text-field
                    label="Aluno"
                    v-model="exam.studentName[idx]"
                    v-if="isEdition"
                    readonly
                    prepend-icon="subject">
                  </v-text-field>
                </v-layout>
              </template>

            </v-flex>
          </v-layout>

          <template v-if="true">

            <v-divider></v-divider>


            <v-layout row>
              <v-flex xs12 md3>
                <v-subheader>Informações da sessão</v-subheader>
              </v-flex>
              <v-flex xs12 md9>

                <v-menu lazy :close-on-content-click="true" v-model="menuReleaseDate"
                  transition="v-scale-transition" offset-y :nudge-left="40">
                  <v-text-field label="Data de divulgação" v-model="formattedReleaseDate" data-vv-as="Data de divulgação" data-vv-name="exam.release_date"
                   :errors="vErrors.collect('exam.release_date')" readonly
                    prepend-icon="date_range" slot="activator"></v-text-field>
                  <v-date-picker v-model="exam.release_date" no-title scrollable locale="pt-BR"></v-date-picker>
                </v-menu>

                <v-menu lazy :close-on-content-click="true" v-model="menuDate"
                  transition="v-scale-transition" offset-y :nudge-left="40" :disabled="readonly">
                  <v-text-field label="Data" v-model="formattedDate" data-vv-as="Data" data-vv-name="exam.date"
                    v-validate="'required'" :errors="vErrors.collect('exam.date')" required readonly
                    prepend-icon="date_range" slot="activator"></v-text-field>
                  <v-date-picker v-model="exam.date" no-title scrollable locale="pt-BR"></v-date-picker>
                </v-menu>
                <v-menu lazy :close-on-content-click="false" v-model="menuTime"
                  transition="v-scale-transition" offset-y :nudge-left="40" :disabled="readonly">
                  <v-text-field label="Hora" v-model="exam.hour" data-vv-as="Hora" data-vv-name="exam.hour"
                    v-validate="'required'" :errors="vErrors.collect('exam.hour')" required readonly
                    prepend-icon="access_time" slot="activator"></v-text-field>
                  <v-time-picker v-model="exam.hour" format="24hr"></v-time-picker>
                </v-menu>
                <v-text-field label="Local" v-model="exam.place" data-vv-as="Local" data-vv-name="exam.place"
                  v-validate="'required'" :errors="vErrors.collect('exam.place')" required
                  prepend-icon="edit_location" :readonly="readonly"></v-text-field>

                <v-text-field label="Vagas" v-model="exam.vacancies" data-vv-as="Vagas" data-vv-name="exam.vacancies"
                  :errors="vErrors.collect('exam.vacancies')"
                  prepend-icon="persons"></v-text-field>
              </v-flex>
            </v-layout>

            <v-divider></v-divider>

            <v-layout row>
              <v-flex xs12 md3>
                <v-subheader>Composição da banca</v-subheader>
              </v-flex>
              <v-flex xs12 md9>

                <v-select label="Orientador" v-model="exam.advisor" data-vv-as="Orientador" data-vv-name="exam.advisor"
                  v-validate="'required'" :errors="vErrors.collect('exam.chair')" required autocomplete
                  prepend-icon="person" :readonly="readonly" :no-data-text="noDataText"
                  :items="teachersComputed" item-text="name" item-value="id"></v-select>

                <v-select label="Presidente" v-model="exam.chair" data-vv-as="Presidente" data-vv-name="exam.chair"
                  v-validate="'required'" :errors="vErrors.collect('exam.chair')" required autocomplete
                  prepend-icon="person" :readonly="readonly" :no-data-text="noDataText"
                  :items="teachersComputed" item-text="name" item-value="id"></v-select>

                <v-checkbox v-model="chairIsExaminer" color="primary" :disabled="readonly">
                  <div slot="label">O presidente também é examinador</div>
                </v-checkbox>

                <template v-for="(examiner, idx) in exam.examiners">
                  <v-layout row>
                    <v-flex xs12 sm11>
                      <v-select :label="'Examinador '+(idx+1)" v-model="exam.examiners[idx]"
                        prepend-icon="person" :rules="[(v) => !!v || 'O examinador ' +(idx+1)+ ' precisa ser informado']" required autocomplete :readonly="readonly"
                        :items="teachersComputed" item-text="name" item-value="id"></v-select>
                    </v-flex>
                    <v-flex xs12 sm1 v-if="!readonly">
                      <v-btn fab dark small class="red" @click="exam.examiners.splice(idx, 1)">
                        <v-icon dark>remove</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>

                <v-layout row class="mb-4" v-if="!readonly">
                  <v-flex xs12 sm9>
                    <v-btn dark small class="green" @click="exam.examiners.push('')">
                      <v-icon dark>add</v-icon> Adicionar examinador
                    </v-btn>
                  </v-flex>
                </v-layout>
                <template v-for="(substitute, idx) in exam.substitutes">
                  <v-layout row>
                    <v-flex xs12 sm11>
                      <v-select :label="'Suplente '+(idx+1)" v-model="exam.substitutes[idx]" :no-data-text="noDataText"
                        prepend-icon="person" :rules="[(v) => !!v || 'O suplente ' +(idx+1)+ ' precisa ser informado']" required autocomplete :readonly="readonly"
                        :items="teachers" item-text="name" item-value="id"></v-select>
                    </v-flex>
                    <v-flex xs12 sm1 v-if="!readonly">
                      <v-btn fab dark small class="red" @click="exam.substitutes.splice(idx, 1)">
                        <v-icon dark>remove</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
                <v-layout row class="mb-4" v-if="!readonly">
                  <v-flex xs12 sm9>
                    <v-btn dark small class="green" @click="exam.substitutes.push('')">
                      <v-icon dark>add</v-icon> Adicionar suplente
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row class="mb-4" v-if="!readonly">
                  <v-flex xs12 sm9>
                    <v-btn dark small class="green" @click="externalExaminerDialog = true">
                      <v-icon dark>person_add</v-icon> Cadastrar avaliador externo
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider></v-divider>

            <v-layout row>
              <v-flex xs12 text-xs-center>
                <v-alert info :value="vErrors.any()">
                  Algum campo não foi preenchido corretamente. Revise o preenchimento dos dados para continuar.
                  {{ vErrors.all() }}
                </v-alert>
                <v-alert error :value="submitErrors">
                  Ocorreram os seguintes erros na submissão do formulário:
                  <ul>
                    <li v-for="error in submitErrors">{{ error }}</li>
                  </ul>
                </v-alert>
                <v-btn dark color="success" type="submit" :disabled="vErrors.any()" v-if="exam.finalScore == 0">
                  <v-icon left dark>done</v-icon> Confirmar
                </v-btn>
              </v-flex>
            </v-layout>
          </template>
        </v-form>

        <v-layout row v-if="submited">
          <v-flex xs12>
              <v-card>
                <v-card-title class="green darken-1">
                  <span class="white--text">Registro confirmado</span>
                </v-card-title>
                <v-card-text height="75px">
                  <v-icon class="mr-4" dark>done</v-icon>
                  O registro de planejamento de banca foi {{ edit ? 'atualizado' : 'registrado' }} com sucesso no sistema sob o
                    <v-chip class="green darken-1 white--text">
                      <router-link :to="{ name: 'examPlan', params: { id: exam.id } }">n.º {{ exam.id }}</router-link>
                    </v-chip>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn dark class="green darken-1" href="/bancas/planejar" @click="reset">
                    Planejar outra banca
                  </v-btn>
                </v-card-actions>
              </v-card>
          </v-flex>
        </v-layout>

      </v-container>
    </v-card-text>

    <v-alert :value="true" error v-if="exam.finalScore > 0">Esta banca já teve a decisão final registrada.</v-alert>

    <v-alert :value="true" error v-if="fatalError">
        Erro ao carregar dados.
        <template v-if="id > 0">Certifique-se de que a banca {{ id }} existe e você tem acesso a ela.</template>
    </v-alert>

    <fullscreen-spinner></fullscreen-spinner>

    <v-dialog v-model="externalExaminerDialog" fullscreen lazy>
        <register-external-examiner v-on:registered="externalExaminerRegistered">
            <template slot="actions">
                <v-spacer></v-spacer>
                <v-btn color="info" @click="externalExaminerDialog = false">Fechar</v-btn>
            </template>
        </register-external-examiner>
    </v-dialog>

  </v-card>
</template>

<script>
import ExamMixin from "./ExamMixin";

export default {
  name: "ExamPlan",
  mixins: [ExamMixin],
  data() {
    return {
      isEdition: false,
      nCourseTypes: []
    };
  },
  created: function() {
    let param = this.$route.params.id;
    this.isEdition = param != undefined ? true : false;
  },
  updated: function() {
    if(this.isEdition){
      this.nCourseTypes = this.courseTypes;
    }
  },
  methods: {
    checkStudent: function() {},
    getExamTypes: function(v){
      // Load types
      this.$http.post("examTypes", { curso: v }).then(
        response => {
          this.nCourseTypes = response.body;
        },
        response => {
          console.error("Erro ao buscar relação de tipos de banca.");
          console.debug(response);
        }
      );
    }
  },
  computed: {
    semesters() {
      let semesters = [{ id: "20172", name: "2017.2" }],
        currentYear = new Date().getFullYear(),
        currentSemester = new Date().getMonth() <= 6 ? 1 : 2;
      for (let year = 2018; year <= currentYear; year++) {
        semesters.push({ id: year + "1", name: year + ".1" });
        if (year < currentYear || currentSemester == 2) {
          semesters.push({ id: year + "2", name: year + ".2" });
        }
      }
      semesters.reverse();
      return semesters;
    },
    teachersComputed() {
      let aTcher = [];

      this.teachers.forEach(function(e, i, a, t){
        let aux = {id: e.id, name: '[' + e.id + '] ' + e.name};
        aTcher.push(aux);
      });

      return aTcher;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// ExamPlan.vue?695770c6